/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosTab } from '../../models/pos-tab';

export interface PosTabsControllerCancelTab$Params {
  id: string;
}

export function posTabsControllerCancelTab(http: HttpClient, rootUrl: string, params: PosTabsControllerCancelTab$Params, context?: HttpContext): Observable<StrictHttpResponse<PosTab>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerCancelTab.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosTab>;
    })
  );
}

posTabsControllerCancelTab.PATH = '/pos/tabs/{id}/cancel';
